// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import * as React from "react";

const InWarehouse: React.FC = () => {
    return <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 54 43.2"  strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" focusable="false" width="24" height="24" fill="currentColor"><path d="M52.5 1.1c-.2-.2-.6-.2-.8-.1L14.9 8V1.6c0-.3-.1-.6-.4-.8-.3-.2-.6-.3-1-.2L6.8 3c-.3.1-.7.5-.7.9v5.8l-4.1.8c-.5 0-.9.5-.9 1v30c0 .6.4 1 1 1h49.8c.6 0 1-.4 1-1V1.8c0-.3-.1-.6-.4-.7zM38.1 21.5v18.3H15.9V21.5h22.2zM8.9 9V5.2l3.2-1.1v4.4L8.9 9zm31 9.8H14.1c-.5 0-1 .4-1 1v20H3.9V13l46.2-9v35.8h-9.2v-20c0-.6-.4-1-1-1z"/></svg>;
};

export default React.memo(InWarehouse);
